import { toFiniteNumber } from 'utils/math/math.utils';
import { getValidMapPosition } from 'utils/maps/coordinate.utils';

export const normalizeEarthquakes = (records = []) => {
  return (Array.isArray(records) ? records : [])
    .map((record) => {
      const position = getValidMapPosition(record?.latitude, record?.longitude);
      if (!position) return null;

      const [latitude, longitude] = position;

      const occurrence = record?.occurrence ?? '';

      return {
        ...record,
        id: String(record?.id ?? `${occurrence}-${latitude}-${longitude}`),
        city: record?.city?.trim() || 'Unknown location',
        latitude,
        longitude,
        position,
        magnitude: toFiniteNumber(record?.magnitude) ?? 0,
        depth: toFiniteNumber(record?.depth),
        occurrence,
      };
    })
    .filter(Boolean);
};
